import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import { BottomNextButton } from "components/common/BottomNextButton";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { onboardingApi } from "../../../../api/onboardingApi";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../../recoil/userAtom";

const SINGLE_PLAN_PRICES: Record<string, string> = {
  e: "395,000",
  h: "595,000",
  i: "695,000",
};

export default function Habit_6() {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);

  const pricingModel = user?.pricingModel ?? "";
  const isSinglePlan = pricingModel in SINGLE_PLAN_PRICES;
  const singlePlanPrice = isSinglePlan ? SINGLE_PLAN_PRICES[pricingModel] : "";

  const handleNext = () => {
    navigate(`/onboarding_new/habit/7`);
  };

  const pageKey = "habit_6";

  const { mutate: savePage } = useMutation(
    (pageId: string) => onboardingApi.savePage(pageId),
    {
      onSuccess: () => {},
    }
  );

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {
    savePage(pageKey);
  });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "70vh" }}>
      <Stack
        spacing={2}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <CustomTypography
          variant="Subtitle"
          fontWeight={700}
          sx={{
            color: theme.vars.palette.Content.Highlight,
          }}
        >
          {isSinglePlan
            ? "매일 쌓여가는 변화"
            : "내게 맞는 플랜을 선택할 수 있습니다."}
        </CustomTypography>

        {isSinglePlan ? (
          <>
            <CustomTypography
              variant="Subtitle"
              fontWeight={500}
              sx={{
                color: theme.vars.palette.Content.Strong,
              }}
            >
              {
                "디스턴싱은 하루 1회, 꾸준히 참여하며 차곡차곡 변화를 쌓아가는 프로그램입니다."
              }
            </CustomTypography>
            <CustomTypography
              variant="Subtitle"
              fontWeight={500}
              sx={{
                color: theme.vars.palette.Content.Strong,
              }}
            >
              {`프로그램은 100일간 진행되며, 비용은 ${singlePlanPrice}원입니다.`}
            </CustomTypography>
          </>
        ) : (
          <>
            <CustomTypography
              variant="Subtitle"
              fontWeight={500}
              sx={{
                color: theme.vars.palette.Content.Strong,
              }}
            >
              {
                "매일 2회씩 프리미엄 코칭을 받으며 빠르고 밀도 있는 변화를 원한다면 마스터 플랜(465,000원)을 선택하세요."
              }
            </CustomTypography>
            <CustomTypography
              variant="Subtitle"
              fontWeight={500}
              sx={{
                color: theme.vars.palette.Content.Strong,
              }}
            >
              {
                "하루 1회 참여하며 차곡차곡 변화를 만들어가고 싶다면 챌린저 플랜(395,000원)이 적합합니다."
              }
            </CustomTypography>
          </>
        )}
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
